import { Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

const SwiperBlock = ({ children }) => {
    return (
        <Swiper
            modules={[Navigation, Autoplay]}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
            navigation
        >
            { children && children.length > 0 && children.map( ( item, i ) => {
                return (
                    <SwiperSlide key={i}><img src={item} /></SwiperSlide>
                )
            })}
        </Swiper>
    )
}


export default SwiperBlock;